// import { Book, CreateFavoriteDto, Favorite, FavoritesState } from "@/app/types";
// import apiClient from "@/app/utils/apiClient";
// import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

// // =======================================================================
// // =======    ADD TO FAVORITES & REMOVER FROM FAVORITES     ==============
// // =======================================================================

// // ADD TO FAVORTIES
// export const addToFavorites = createAsyncThunk<
//   Favorite,
//   CreateFavoriteDto,
//   { rejectValue: string }
// >("favorites/addToFavorites", async (payload, { rejectWithValue }) => {
//   try {
//     const res = await apiClient.post("/favorites", payload);
//     return res.data;
//   } catch (err: any) {
//     return rejectWithValue(
//       err.response?.data?.message || "Failed to add to favorites",
//     );
//   }
// });

// // REMOVE FROM FAVORITES
// export const removeFromFavorites = createAsyncThunk<
//   string, // we return favoriteId
//   string, // input is favoriteId
//   { rejectValue: string }
// >("favorites/removeFromFavorites", async (bookId, { rejectWithValue }) => {
//   try {
//     await apiClient.delete(`/favorites/${bookId}`);
//     return bookId; // return deleted favorite id
//   } catch (err: any) {
//     return rejectWithValue(
//       err.response?.data?.message || "Failed to remove from favorites",
//     );
//   }
// });

// // FETCH FAVORITES BOOKS
// export const fetchMyFavorites = createAsyncThunk<
//   Favorite[],
//   void,
//   { rejectValue: string }
// >("favorites/fetchMyFavorites", async (_, { rejectWithValue }) => {
//   try {
//     const res = await apiClient.get("/favorites/my");
//     return res.data;
//   } catch (err: any) {
//     if (err.response?.status === 401) return rejectWithValue("SILENT");
//     return rejectWithValue(
//       err.response?.data?.message || "Failed to load favorites",
//     );
//   }
// });

// // =======================================================================
// // =======    ADD TO FAVORITES & REMOVER FROM FAVORITES     ==============
// // =======================================================================

// // =======================================================================
// // =========================    FAVORITES SLICE     =======================
// // =======================================================================

// const initialState: FavoritesState = {
//   favoritesBooks: [],
//   loadingBookIds: [],
//   loading: false,
//   error: null,
//   message: null,
// };

// const favoritesSlice = createSlice({
//   name: "favorites",
//   initialState,
//   reducers: {
//     clearFavoriteMessages: (state) => {
//       state.error = null;
//       state.message = null;
//     },
//   },

//   extraReducers: (builder) => {
//     // 🚀 Add to Favorites
//     builder
//       .addCase(addToFavorites.pending, (state, action) => {
//         state.loadingBookIds.push(action.meta.arg.bookId);
//         state.error = null;
//         state.message = null;
//       })
//       .addCase(
//         addToFavorites.fulfilled,
//         (state, action: PayloadAction<Favorite>) => {
//           // state.loading = false;
//           // state.favoritesBooks = [...state.favoritesBooks, action.payload];
//           state.loadingBookIds = state.loadingBookIds.filter(
//             (id) => id !== action.payload.bookId._id,
//           );

//           // avoid duplicates
//           if (
//             !state.favoritesBooks.find(
//               (f) => f.bookId._id === action.payload.bookId._id,
//             )
//           ) {
//             state.favoritesBooks.push(action.payload);
//           }
//           state.message = "Added to favorites";
//         },
//       )
//       .addCase(addToFavorites.rejected, (state, action) => {
//         // state.loading = false;
//         state.loadingBookIds = state.loadingBookIds.filter(
//           (id) => id !== action.meta.arg.bookId,
//         );
//         state.error = action.payload || "Failed to add favorite";
//       });

//     // 🚀 Remove from Favorites
//     builder
//       .addCase(removeFromFavorites.pending, (state, action) => {
//         // state.loading = true;
//         state.loadingBookIds.push(action.meta.arg);
//         state.error = null;
//       })
//       .addCase(
//         removeFromFavorites.fulfilled,
//         (state, action: PayloadAction<string>) => {
//           // state.loading = false;
//           // state.favoritesBooks = state.favoritesBooks.filter(
//           //   (fav) => fav.bookId._id !== action.payload,
//           // );

//           state.loadingBookIds = state.loadingBookIds.filter(
//             (id) => id !== action.payload,
//           );
//           state.favoritesBooks = state.favoritesBooks.filter(
//             // (fav) => fav.bookId._id !== action.payload,
//             (fav) => fav._id !== action.payload,
//           );
//           state.message = "Removed from favorites";
//         },
//       )

//       .addCase(removeFromFavorites.rejected, (state, action) => {
//         // state.loading = false;
//         state.loadingBookIds = state.loadingBookIds.filter(
//           (id) => id !== action.meta.arg,
//         );
//         state.error = action.payload || "Failed to remove favorite";
//       });

//     // 🚀 Fetch My Favorites
//     builder
//       .addCase(fetchMyFavorites.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(
//         fetchMyFavorites.fulfilled,
//         (state, action: PayloadAction<Favorite[]>) => {
//           state.loading = false;
//           state.favoritesBooks = action.payload;
//         },
//       )
//       .addCase(fetchMyFavorites.rejected, (state, action) => {
//         state.loading = false;
//         if (action.payload !== "SILENT") {
//           state.error = action.payload || "Failed to load favorites";
//         }
//       });
//   },
// });

// export const { clearFavoriteMessages } = favoritesSlice.actions;
// export default favoritesSlice.reducer;

// store/slices/favoriteSlice.ts
import { Book, CreateFavoriteDto, Favorite, FavoritesState } from "@/app/types";
import apiClient from "@/app/utils/apiClient";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

// =======================================================================
// =======    ADD TO FAVORITES & REMOVER FROM FAVORITES     ==============
// =======================================================================

// ADD TO FAVORITES
export const addToFavorites = createAsyncThunk<
  Favorite,
  CreateFavoriteDto,
  { rejectValue: string }
>("favorites/addToFavorites", async (payload, { rejectWithValue }) => {
  try {
    const res = await apiClient.post("/favorites", payload);
    return res.data;
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || "Failed to add to favorites",
    );
  }
});

// REMOVE FROM FAVORITES
export const removeFromFavorites = createAsyncThunk<
  string, // we return favoriteId
  string, // input is favoriteId (the favorite document ID)
  { rejectValue: string }
>("favorites/removeFromFavorites", async (favoriteId, { rejectWithValue }) => {
  try {
    await apiClient.delete(`/favorites/${favoriteId}`);
    return favoriteId; // return deleted favorite id
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data?.message || "Failed to remove from favorites",
    );
  }
});

// FETCH FAVORITES BOOKS
export const fetchMyFavorites = createAsyncThunk<
  Favorite[],
  void,
  { rejectValue: string }
>("favorites/fetchMyFavorites", async (_, { rejectWithValue }) => {
  try {
    const res = await apiClient.get("/favorites/my");
    return res.data;
  } catch (err: any) {
    if (err.response?.status === 401) return rejectWithValue("SILENT");
    return rejectWithValue(
      err.response?.data?.message || "Failed to load favorites",
    );
  }
});

// =======================================================================
// =========================    FAVORITES SLICE     =======================
// =======================================================================

const initialState: FavoritesState = {
  favoritesBooks: [],
  loadingBookIds: [],
  loading: false,
  error: null,
  message: null,
};

const favoritesSlice = createSlice({
  name: "favorites",
  initialState,
  reducers: {
    clearFavoriteMessages: (state) => {
      state.error = null;
      state.message = null;
    },
  },

  extraReducers: (builder) => {
    // 🚀 Add to Favorites
    builder
      .addCase(addToFavorites.pending, (state, action) => {
        state.loadingBookIds.push(action.meta.arg.bookId);
        state.error = null;
        state.message = null;
      })
      .addCase(
        addToFavorites.fulfilled,
        (state, action: PayloadAction<Favorite>) => {
          // Remove the bookId from loading state
          state.loadingBookIds = state.loadingBookIds.filter(
            (id) => id !== action.payload.bookId?._id,
          );

          // Check if favorite already exists (avoid duplicates)
          const exists = state.favoritesBooks.some(
            (fav) => fav.bookId?._id === action.payload.bookId?._id,
          );

          if (!exists) {
            state.favoritesBooks.push(action.payload);
          }
          state.message = "Added to favorites";
        },
      )
      .addCase(addToFavorites.rejected, (state, action) => {
        state.loadingBookIds = state.loadingBookIds.filter(
          (id) => id !== action.meta.arg.bookId,
        );
        state.error = action.payload || "Failed to add favorite";
      });

    // 🚀 Remove from Favorites
    builder
      .addCase(removeFromFavorites.pending, (state, action) => {
        // action.meta.arg is the favorite document ID
        state.loadingBookIds.push(action.meta.arg);
        state.error = null;
      })
      .addCase(
        removeFromFavorites.fulfilled,
        (state, action: PayloadAction<string>) => {
          // Remove the favorite ID from loading state
          state.loadingBookIds = state.loadingBookIds.filter(
            (id) => id !== action.payload,
          );

          // Remove the favorite from the list by favorite document ID
          state.favoritesBooks = state.favoritesBooks.filter(
            (fav) => fav._id !== action.payload,
          );
          state.message = "Removed from favorites";
        },
      )
      .addCase(removeFromFavorites.rejected, (state, action) => {
        state.loadingBookIds = state.loadingBookIds.filter(
          (id) => id !== action.meta.arg,
        );
        state.error = action.payload || "Failed to remove favorite";
      });

    // 🚀 Fetch My Favorites
    builder
      .addCase(fetchMyFavorites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchMyFavorites.fulfilled,
        (state, action: PayloadAction<Favorite[]>) => {
          state.loading = false;
          state.favoritesBooks = action.payload;
        },
      )
      .addCase(fetchMyFavorites.rejected, (state, action) => {
        state.loading = false;
        if (action.payload !== "SILENT") {
          state.error = action.payload || "Failed to load favorites";
        }
      });
  },
});

export const { clearFavoriteMessages } = favoritesSlice.actions;
export default favoritesSlice.reducer;
